import { Injectable, signal } from '@angular/core';

/** Müşteri portalı (paket yükseltme) adresi. */
const UPGRADE_PORTAL_URL = 'https://portal.jestiyon.com';

/** "Emin değil misiniz?" görüşme planlama (Calendly) adresi. */
const MEETING_URL = 'https://calendly.com/jestiyon/meet';

/**
 * Paket yükseltme (upsell) modalını uygulama genelinde tek noktadan yönetir. Kilitli bir
 * 'upgrade' özelliğine (nav öğesi, rapor kartı, buton vb.) tıklanınca `openPrompt(featureName?)`
 * çağrılır; modal shell'de tek örnek olarak render edilir (UpgradeModalComponent).
 *
 * `featureName` verilirse (kullanıcının açmaya çalıştığı özelliğin yerelleştirilmiş adı) modal
 * başlığı bağlama göre kişiselleştirilir.
 */
@Injectable({ providedIn: 'root' })
export class UpgradePromptService {
  readonly open = signal(false);

  /** Kullanıcının açmaya çalıştığı kilitli özelliğin yerelleştirilmiş adı (varsa). */
  readonly featureName = signal<string | null>(null);

  openPrompt(featureName?: string): void {
    this.featureName.set(featureName?.trim() || null);
    this.open.set(true);
  }

  close(): void {
    this.open.set(false);
  }

  /** Plan kartlarındaki "Başlayın" butonu: müşteri portalını yeni sekmede açar ve modalı kapatır. */
  openPortal(): void {
    window.open(UPGRADE_PORTAL_URL, '_blank', 'noopener');
    this.open.set(false);
  }

  /** "Emin değil misiniz? Görüşme planlayın": Calendly'yi yeni sekmede açar ve modalı kapatır. */
  openMeeting(): void {
    window.open(MEETING_URL, '_blank', 'noopener');
    this.open.set(false);
  }
}
